import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { from, Observable } from 'rxjs';
import { SignageErrorCode } from '../../signage/types/signage-error-code';
import { ADMIN_CONTEXT, ADMIN_LOGIN_ROUTE, ADMIN_PAIR_ROUTE, PAIRING_CONTEXT, SIGNAGE_CONTEXT, SIGNAGE_DISPLAY_LAYOUT_ROUTE, SIGNAGE_ERROR_ROUTE } from '../consts/route-names';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public readonly router = inject(Router);

  public readonly initializationUrl: string;
  public readonly adminUrl: string;
  public readonly adminLoginUrl: string;
  public readonly pairingUrl: string;
  public readonly signageUrl: string;
  public readonly signageDisplayLayoutUrl: string;

  constructor() {
    this.initializationUrl = '/';
    this.adminUrl = `/${ADMIN_CONTEXT}`;
    this.adminLoginUrl = `/${ADMIN_CONTEXT}/${ADMIN_LOGIN_ROUTE}`;
    this.pairingUrl = `/${PAIRING_CONTEXT}`;
    this.signageUrl = `/${SIGNAGE_CONTEXT}`;
    this.signageDisplayLayoutUrl = `/${SIGNAGE_CONTEXT}/${SIGNAGE_DISPLAY_LAYOUT_ROUTE}`;
  }

  public navigateByUrl(url: string | UrlTree): Observable<boolean> {
    return from(this.router.navigateByUrl(url));
  }

  public adminLoginWithRedirectUrl(url: string): UrlTree {
    const urlTree = this.router.parseUrl(this.adminLoginUrl);
    urlTree.queryParams = {
      redirect: url
    };
    return urlTree;
  }

  public adminPairUrl(transactionId: string): string {
    return [
      this.adminUrl,
      ADMIN_PAIR_ROUTE,
      transactionId
    ].join('/');
  }

  public signageErrorUrl(code: SignageErrorCode): string {
    return `/${SIGNAGE_CONTEXT}${this.signageErrorInContextUrlPart(code)}`;
  }

  public signageErrorInContextUrlPart(code: SignageErrorCode): string {
    return this.router.createUrlTree([
      SIGNAGE_ERROR_ROUTE
    ], {
      queryParams: { code }
    }).toString();
  }

}
